import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ChecklistTemplateID } from "models";

export const useDeleteTemplateMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: { id: ChecklistTemplateID }) => (await ApiInstance.post("/checklists/template/delete", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const templates = typedQueryClient.getQueryData(ChecklistSettingsDashboardQueryKeys.checklistTemplates);
      if (!templates) return;

      const templateIdx = templates.findIndex(template => template.checklist_template_id === payload.id);
      if (templateIdx < 0) return;

      typedQueryClient.setQueryData(ChecklistSettingsDashboardQueryKeys.checklistTemplates, templates.toSpliced(templateIdx, 1));
    }
  });
